module.exports = __webpack_public_path__ + "img/urinary.dbca58cc.svg";